// extracted by mini-css-extract-plugin
export default {"root":"AddNetworkForm_root__H16xZ","submit":"AddNetworkForm_submit__N0tfK"};